import { useQuery, useMutation } from '@tanstack/react-query';

const useQueryHook = (queryKey, queryFn, options = {}) => useQuery({ queryKey, queryFn, ...options });

const useMutationHook = (mutationKey, mutationFn, options = {}) => useMutation({ mutationKey, mutationFn, ...options });

export { useQueryHook, useMutationHook };
